import {
  Component,
  ViewEncapsulation,
  ContentChildren,
  QueryList,
  AfterContentInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges,
  ChangeDetectorRef,
ChangeDetectionStrategy, } from '@angular/core';

import { TabComponent } from './tab.component';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class TabsComponent implements AfterContentInit, OnChanges {
  @Input() justifyContent;
  @Input() tabActive;
  @ContentChildren(TabComponent) tabs: QueryList<TabComponent>;
  @Output() tabChange = new EventEmitter<any>();

  tabPrev = null;
  tabCurrent = null;

  constructor(private cdr: ChangeDetectorRef) {}

  private runAfterChangeDetection(fn: () => void) {
    Promise.resolve().then(() => {
      fn();
      this.cdr.detectChanges();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.tabActive && changes.tabActive.currentValue) {
      this.runAfterChangeDetection(() => this.setActiveTabManualChange(changes.tabActive.currentValue));
    }
  }

  ngAfterContentInit() {
    this.runAfterChangeDetection(() => {
      let activeTabs;

      if (this.tabActive) {
        activeTabs = this.tabs.filter((tab) => tab.id === this.tabActive);
      } else {
        activeTabs = this.tabs.filter((tab) => tab.active);
      }

      if (activeTabs.length === 0) {
        this.selectTab(this.tabs.first);
      } else {
        this.selectTab(activeTabs[0]);
      }
    });
  }

  // Обработчик на активацию табы привязанный на изменение входного значения tabActive
  setActiveTabManualChange(tabId) {
    if (!this.tabs) {
      return;
    }

    this.tabs.toArray().forEach((tab) => {
      if (tab.id !== tabId) {
        tab.active = false;
      } else {
        this.selectTab(tab);
      }
    });
  }

  // Клик по самой табе
  selectTab(tab) {
    if (this.tabCurrent && this.tabCurrent.doCheck && !this.tabCurrent.doCheck(tab)) {
      return;
    }

    this.tabs.toArray().forEach((t) => (t.active = false));
    tab.active = true;
    this.tabPrev = this.tabCurrent;
    this.tabCurrent = tab;
    this.tabChange.emit({ currentTab: tab, previewTab: this.tabPrev });
    // this.tabChange.emit(tab);
  }
}
